import React, { useEffect, useState } from 'react';
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";
import { supabase } from './shared/infra/auth/SupabaseClient';
import Login from "./pages/login/Login";
import ResetPassword from "./pages/login/ResetPassword";
import DocMarkup from "./pages/documentation/MarkupDocumentation";
import DraftEditor from "./pages/draft/DraftEditor";
import DraftList from "./pages/draft/DraftList";
import PageViewer from "./pages/lecture/Lecture";
import { handleLogout } from './pages/login/logout';
import Home from "./pages/home/Home";

const App = () =>  {
  const [session, setSession] = useState(null)
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (!session) {
    return (
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </BrowserRouter>
    );
  }
  else {
    
    return (
        <BrowserRouter>
          <nav className="navigation">
            <ul className="menu">
              <li>
                <Link to="/home">Home</Link>
              </li>
              <li>
                <Link to="/drafts">My drafts</Link>
              </li>
              <li>
                <Link to="/lecture">Lecture</Link>
              </li>
              <li>
                <Link to="/doc/editor/markup">Markup documentation</Link>
              </li>
              <li className="logout-item">
                <Link to="/" onClick={handleLogout}>Logout</Link>
              </li>
            </ul>
          </nav>
          <Routes>
            <Route path="/" element={<PageViewer />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/lecture" element={<PageViewer />} />
            <Route path="/draft" element={<DraftEditor />} />
            <Route path="/drafts" element={<DraftList />} />
            <Route path="/doc/editor/markup" element={<DocMarkup />} />
            // must be logged in or use reset link to reset password
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </BrowserRouter>
    )
  }
}

export default App;
